import { createContext } from 'react'
import { VWAM_SIGNUP_URL } from '@/lib/links'
import type {
  TrackerAnalytics,
  TrackerAuth,
  TrackerFetcher,
  TrackerSurface,
} from './TrackerProvider.types'

const noopAnalytics: TrackerAnalytics = { track: () => {} }
export const FetcherContext = createContext<TrackerFetcher | undefined>(
  undefined
)
export const AuthContext = createContext<TrackerAuth>(null)
export const AnalyticsContext = createContext<TrackerAnalytics>(noopAnalytics)
export const BasenameContext = createContext<string>('')
export const SignupUrlContext = createContext<string>(VWAM_SIGNUP_URL)
export const SurfaceContext = createContext<TrackerSurface>('free')
export const DocsBaseUrlContext = createContext<string>('')
